// The COW IOP demo is served as a static app from public/index.html.
// React mounts only if a #root element exists (it does not in the demo).
const rootEl = document.getElementById("root");
if (rootEl) {
  import("./legacy-mount").then((m) => m.mount(rootEl));
}
